import { createFileRoute, notFound } from "@tanstack/react-router";
import { CatalogCategoryPage } from "@/components/sections/catalog-pages";
import { getCatalogCategory } from "@/lib/services-catalog";

export const Route = createFileRoute("/services/hrm-payroll/")({
  component: HrmIndex,
  head: () => ({
    meta: [
      { title: "HRM & Payroll — CoderLity" },
      { name: "description", content: "End-to-end HR: applicant tracking, employee records, attendance, leave, payroll and tax compliance." },
      { property: "og:title", content: "HRM & Payroll — CoderLity" },
      { property: "og:description", content: "People operations, hiring to payroll." },
      { property: "og:url", content: "/services/hrm-payroll" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/services/hrm-payroll" }],
  }),
});

function HrmIndex() {
  const cat = getCatalogCategory("hrm-payroll");
  if (!cat) throw notFound();
  return <CatalogCategoryPage cat={cat} />;
}
